import React, { useEffect } from 'react'
import { Button, Modal } from 'react-bootstrap';
import Cards from 'react-credit-cards';
import InputField from '../../jsx/components/fields/inputField';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import creditCardType from 'credit-card-type';
import { createPaymentMethodByCustomerId } from '../../service/api/paymentGateway/createPaymentMethodByCustomerId';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import ResponceForAPI from '../../component/backDrop/responcesForAPI';

import { Elements, CardElement, useStripe, useElements, CardNumberElement } from '@stripe/react-stripe-js';
import CardInput from './cardElements/cardInput';
import { CardNumberInput, CardExpiryInput, CardCvcInput } from './cardElements/cardInput';
import axios from 'axios';
import StandardInputField from '../../jsx/components/fields/standardInputField';
import { isPostalCode } from 'validator';


const AddNewCard = ({ addNewCardTrigger, handleCloseAddNewCard }) => {

    const { paymentMethodID, customerID } = useSelector((state) => state.user);

    const dispatch = useDispatch();
    const [cardInfo, setCardInfo] = useState({
        cardNumber: '',
        expiryDate: '',
        cvc: '',
        cardHolder: '',
        focus: '',
    });

    // console.log(cardInfo)

    const [isCardHolderNameErr, setIsCardHolderNameErr] = useState(false);
    const [isCardNumberErr, setIsCardNumberErr] = useState(false);
    const [isCardExpErr, setIsCardExpErr] = useState(false);
    const [isCardCVCErr, setIsCardCVCErr] = useState(false);

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);
    const [apiResponce, setApiResponse] = useState(false);

    const [formatedNumber, setFormatedNumber] = useState("");

    const handleCardNumberChange = (e) => {
        setIsCardNumberErr(false);
        // Remove anything that's not a digit
        const newValue = e.target.value?.replace(/\D/g, '');

        // Add spaces after every 4 digits for display
        const formattedValue = newValue?.replace(/(\d{4})/g, '$1 ').trim();

        // Update the actual input value
        e.target.value = formattedValue;

        setFormatedNumber(formattedValue)

        // Update state without spaces
        setCardInfo({
            ...cardInfo,
            cardNumber: newValue
        });
    };

    const handleExpiryDateChange = (e) => {
        setIsCardExpErr(false);
        let value = e.target.value?.replace(/\D/g, '');
        if (value.length > 4) value = value.substr(0, 4); // Maximum length of 4 digits
        if (value.length > 2) value = value.substr(0, 2) + '/' + value.substr(2); // Insert slash after two digits

        setCardInfo({
            ...cardInfo,
            expiryDate: value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'cardHolder') {
            setIsCardHolderNameErr(false)
        }

        setCardInfo({
            ...cardInfo,
            [name]: value
        });
    };

    const handleCVCChange = (e) => {
        setIsCardCVCErr(false)
        const newValue = e.target.value?.replace(/\D/g, ''); // Remove non-digit characters
        setCardInfo({
            ...cardInfo,
            cvc: newValue
        });
    };

    const handleInputFocus = (e) => {
        const { name } = e.target;
        setCardInfo({
            ...cardInfo,
            focus: name
        });
    };

    const handleCardHolderNameBlurCheck = () => {
        if (cardInfo.cardHolder.trim() === '') {
            setIsCardHolderNameErr(true);
        }
    }

    const handleCardNumberBlurCheck = () => {
        // console.log(!validateCardNumber(Number(cardInfo.cardNumber)))
        // console.log(cardInfo.cardNumber, typeof cardInfo.cardNumber, 'handleCardNumberBlurCheck')

        const cardType = creditCardType(cardInfo.cardNumber);
        // console.log(cardType, 'cardType')

        if (cardInfo.cardNumber.length !== 16 || cardType.length === 0
            // || !validator.isCreditCard(cardInfo.cardNumber)
        ) {
            setIsCardNumberErr(true);
        }
    }

    const handleCardExpBlurCheck = () => {
        const [month, year] = cardInfo.expiryDate.split('/');
        if (cardInfo.expiryDate.trim() === ""
            || cardInfo.expiryDate.trim().length != 5
            || Number(month) > 12
            || Number(year) < Number((new Date()).getFullYear().toString().slice(-2))) {
            setIsCardExpErr(true);
        }
    }

    const handleCardCVCBlurCheck = () => {
        if (cardInfo.cvc.length < 3 || cardInfo.cvc.trim() === "") {
            setIsCardCVCErr(true);
        }
    }



    const handleSubmit = async (e) => {
        e.preventDefault();

        // setApiResponse(true);


        const [month, year] = cardInfo.expiryDate.split('/');
        if (cardInfo.cardHolder.trim() === '') {
            setIsCardHolderNameErr(true);
            setApiResponse(false);
        }

        const cardType = creditCardType(cardInfo.cardNumber);

        if (cardInfo.cardNumber.length !== 16 || cardType.length === 0
            // || !validator.isCreditCard(cardInfo.cardNumber)
        ) {
            setIsCardNumberErr(true);
        }
        if (cardInfo.expiryDate.trim() === ""
            || cardInfo.expiryDate.trim().length != 5
            || Number(month) > 12
            || Number(year) < Number((new Date()).getFullYear().toString().slice(-2))) {
            setIsCardExpErr(true);
            setApiResponse(false);
        }
        if (cardInfo.cvc.length < 3 || cardInfo.cvc.trim() === "") {
            setIsCardCVCErr(true);
            setApiResponse(false);
        }

        if ((cardInfo.cardHolder.trim() === '') ||
            (cardInfo.cardNumber.length !== 16) ||
            (cardType.length === 0) ||
            // !validator.isCreditCard(cardInfo.cardNumber) ||
            (cardInfo.expiryDate.trim() === ""
                || cardInfo.expiryDate.trim().length != 5
                || Number(month) > 12
                || Number(year) < Number((new Date()).getFullYear().toString().slice(-2))) ||
            (cardInfo.cvc.length < 3 || cardInfo.cvc.trim() === "")) {
            setApiResponse(false);
            return
        }

        if (!isCardHolderNameErr && !isCardNumberErr && !isCardExpErr && !isCardCVCErr) {
            // Here you can handle the submission of the credit card information.
            // You would typically send this to a server that can process the payment using a third-party payment processor.

            let details = new FormData();

            details.append("customer_id_ids", customerID);
            details.append("name_on_card", cardInfo.cardHolder);
            details.append("card_number", parseInt(cardInfo.cardNumber));
            details.append("expiry_month", parseInt(month));
            details.append("expiry_year", parseInt(year));
            details.append("card_cvc_number", parseInt(cardInfo.cvc));
            details.append("token_chr", "tok_visa");

            dispatch(
                createPaymentMethodByCustomerId(
                    details,
                    (res) => {
                        // console.log(res)

                        setResponceMsg(res.data.message)
                        setToasterType("success")

                        handleCloseAddNewCard()
                        setApiResponse(false);

                        // setTimeout(() => {
                        //     handleCloseAddNewCard()
                        //     setApiResponse(false);
                        // }, 1500);

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 11000);
                    },
                    (res) => {
                        // console.log(res)
                        setResponceMsg(res.data.message)
                        setToasterType("error");

                        setApiResponse(false);

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            )
        }
    };

    const stripe = useStripe();
    const elements = useElements();

    const handleSubmitStripe = async (event) => {
        event.preventDefault();
        setApiResponse(true);

        const isValidZipCode = validateZipCode();

        // console.log(isValidZipCode, 'isValidZipCode');

        if (cardInfo.cardHolder.trim() === '' || !isValidZipCode) {
            if (cardInfo.cardHolder.trim() === '') {
                setIsCardHolderNameErr(true);
                setApiResponse(false);
            }

            // if (zipCode.trim() === '') {
            //     setIsZipCodeErr(true);
            //     setApiResponse(false);
            // }

        } else {
            if (!stripe || !elements) {
                // Ensure Stripe.js has loaded
                // console.log('Stripe has not loaded yet');
                setApiResponse(false);

                setResponceMsg('Stripe has not loaded yet')
                setToasterType("error");
                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);

                return;
            }

            // const cardElement = elements.getElement(CardElement);
            const cardElement = elements.getElement(CardNumberElement);


            // const cardNumberElement = elements.getElement(CardNumberInput);
            // const cardExpiryElement = elements.getElement(CardExpiryInput);
            // const cardCvcElement = elements.getElement(CardCvcInput);

            const { error, token } = await stripe.createToken(cardElement, {
                address_zip: zipCode,
            });

            if (error) {
                // console.log('Error:', error.message);
                setApiResponse(false);

                // setResponceMsg(error.message)
                // setToasterType("error");
                // setHandleToaster(true);
                // setTimeout(() => {
                //     setHandleToaster(false);
                // }, 2000);

            } else {
                // console.log('Success! Token: ', token);
                // console.log('Token created:', token.id);
                // You can now send the token to your server

                let details = new FormData();

                details.append("customer_id_ids", customerID);
                details.append("name_on_card", cardInfo.cardHolder);
                details.append("token_chr", token.id);
                details.append("zip_code_chr", zipCode);
                details.append("country_code_chr", myCountryCode);


                setApiResponse(true);

                dispatch(
                    createPaymentMethodByCustomerId(
                        details,
                        (res) => {
                            // console.log(res)

                            setResponceMsg(res.data.message)
                            setToasterType("success")

                            handleCloseAddNewCard()
                            setApiResponse(false);

                            // setTimeout(() => {
                            //     handleCloseAddNewCard()
                            //     setApiResponse(false);
                            // }, 1500);

                            // setHandleToaster(true);
                            // setTimeout(() => {
                            //     setHandleToaster(false);
                            // }, 11000);
                        },
                        (res) => {
                            // console.log(res)
                            setResponceMsg(res.data.message)
                            setToasterType("error");

                            setApiResponse(false);

                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }
                    )
                )
            }
        }
    }

    const [cardNumberError, setCardNumberError] = useState('');
    const [cardExpiryError, setCardExpiryError] = useState('');
    const [cardCvcError, setCardCvcError] = useState('');

    const handleCardNumberChangeStripe = (event) => {
        // setCardNumberError(event.error ? event.error.message : '');
        setCardNumberError(event.error ? 'Enter valid card number' : '');
    };

    const handleCardExpiryChangeStripe = (event) => {
        // setCardExpiryError(event.error ? event.error.message : '');
        setCardExpiryError(event.error ? 'Enter valid exp. date' : '');

    };

    const handleCardCvcChangeStripe = (event) => {
        // setCardCvcError(event.error ? event.error.message : '');
        setCardCvcError(event.error ? 'Enter valid cvc' : '');
    };

    const [myCountryCode, setMyCountryCode] = useState('US');

    useEffect(() => {
        const getCountryCode = async () => {
            try {
                const response = await axios.get('https://ipapi.co/json/');
                const data = response.data;
                // console.log(`'My country code:', ${data.country}`)
                setMyCountryCode(data.country);
            } catch (error) {
                // console.log('Error fetching country code:', error);
            }
        };
        getCountryCode();
    }, []);

    const [zipCode, setZipCode] = useState("");
    const [isZipCodeErr, setIsZipCodeErr] = useState(false);
    const handleZipCode = (e) => {
        // setZipCode(e.target.value.replace(/\D/g, ''))
        setZipCode(e.target.value)
        setIsZipCodeErr(false)
    }

    const handleZipCodeBlurCheck = () => {
        // if (zipCode.trim() === '') {
        //     setIsZipCodeErr(true);
        // }
        validateZipCode();
    }

    const validateZipCode = () => {
        if (!zipCode) {
            setIsZipCodeErr(true);
            setApiResponse(false);
            return false;
        } else if (!isPostalCode(zipCode, myCountryCode || 'any')) {
            setIsZipCodeErr(true);
            setApiResponse(false);
            return false;
        }
        setIsZipCodeErr(false);
        return true;
    };


    return (
        <>
            <Modal className="fade" show={addNewCardTrigger} centered>

                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => handleCloseAddNewCard()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                        <span>
                                            {"Add new card"}
                                        </span>
                                    </div>
                                </div>
                                <>
                                    <form onSubmit={handleSubmitStripe}>


                                        <div>
                                            {/* <CardInput /> */}

                                            <div className='row mx-0'>
                                                <div className='col-12 px-0'>
                                                    <label className={`font-w600 mb-1 ${cardNumberError ? 'text-red' : ''}`}>Card number *</label>
                                                    <div
                                                        style={{
                                                            padding: '10px',
                                                            border: cardNumberError ? '1px solid red' : '1px solid #DBDBDB',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <CardNumberInput onChange={handleCardNumberChangeStripe} autocomplete="off" />
                                                    </div>
                                                    {cardNumberError && <div className="text-red fs-12">{cardNumberError}</div>}
                                                </div>
                                            </div>

                                            <div className='row mx-0 mt-2'>
                                                <div className='col-6 pe-2'>
                                                    <label className={`font-w600 mb-1 ${cardExpiryError ? 'text-red' : ''}`}>Expiry date *</label>
                                                    <div
                                                        style={{
                                                            padding: '10px',
                                                            border: cardExpiryError ? '1px solid red' : '1px solid #DBDBDB',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <CardExpiryInput onChange={handleCardExpiryChangeStripe} />
                                                    </div>
                                                    {cardExpiryError && <div className="text-red fs-12">{cardExpiryError}</div>}
                                                </div>

                                                <div className='col-6 ps-2'>
                                                    <label className={`font-w600 mb-1 ${cardCvcError ? 'text-red' : ''}`}>CVC *</label>
                                                    <div
                                                        style={{
                                                            padding: '10px',
                                                            border: cardCvcError ? '1px solid red' : '1px solid #DBDBDB',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <CardCvcInput onChange={handleCardCvcChangeStripe} />
                                                    </div>
                                                    {cardCvcError && <div className="text-red fs-12">{cardCvcError}</div>}
                                                </div>
                                            </div>

                                            <div className='row mx-0 mt-3'>
                                                <div className='col-12 px-0'>
                                                    <StandardInputField
                                                        labelName="Name on card"
                                                        placeholderName={'Name on card'}
                                                        type={'text'}
                                                        name={'cardHolder'}
                                                        value={cardInfo.cardHolder}
                                                        onChange={handleInputChange}
                                                        onFocus={handleInputFocus}
                                                        onBlur={handleCardHolderNameBlurCheck}
                                                        errorOccured={isCardHolderNameErr}
                                                        errorMeesage={'Enter valid cardholder name'}
                                                        isRequired={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className='row mx-0'>
                                                <div className='col-12 px-0'>
                                                    <StandardInputField
                                                        labelName={"Zip code"}
                                                        placeholderName={'Zip code'}
                                                        value={zipCode}
                                                        onChange={(e) => { handleZipCode(e) }}
                                                        onBlur={() => { handleZipCodeBlurCheck() }}
                                                        errorOccured={isZipCodeErr}
                                                        errorMeesage={`Enter valid zip code`}
                                                        isRequired={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className='col-12 px-0  mt-2'>
                                                <PrimaryButton
                                                    onClick={(e) => handleSubmitStripe(e)}
                                                    buttonName={"ADD NEW CARD"}
                                                    type={"submit"}
                                                    loadingMessage={"LOADING..."}
                                                    isLoading={apiResponce}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, rgb(22, 186, 78) 1.99%, rgb(25, 223, 92) 99.97%)',
                                                        border: 'none',
                                                        boxShadow: 'rgba(45, 204, 99, 0.24) 0px 6px 12px 0px',
                                                    }}
                                                    disabled={!stripe}
                                                />
                                            </div>

                                        </div>

                                    </form>

                                </>


                                {/* -------- Custom code to add credit cards ------------ */}
                                {/* <form onSubmit={handleSubmit}>

                                    <div className='row mx-0'>
                                        <div className={`col-12 px-0 `}>
                                            <InputField
                                                labelName="Card number"
                                                placeholderName={'1234 1234 1234 1234'}
                                                type={'text'}
                                                name={'cardNumber'}
                                                value={formatedNumber}
                                                onChange={handleCardNumberChange}
                                                onFocus={handleInputFocus}
                                                maxLength={19}
                                                onBlur={handleCardNumberBlurCheck}
                                                errorOccured={isCardNumberErr}
                                                errorMeesage={'Enter valid card number'}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0 justify-content-between'>
                                        <div className='col-6 px-0 pe-2'>
                                            <InputField
                                                labelName="MM/YY"
                                                placeholderName={'MM/YY'}
                                                type={'text'}
                                                name={'expiryDate'}
                                                value={cardInfo.expiryDate}
                                                onChange={handleExpiryDateChange}
                                                onFocus={handleInputFocus}
                                                onBlur={handleCardExpBlurCheck}
                                                errorOccured={isCardExpErr}
                                                errorMeesage={'Enter valid exp. date'}
                                            />
                                        </div>

                                        <div className='col-6 px-0  ps-2'>
                                            <InputField
                                                labelName="CVV"
                                                placeholderName={'CVV'}
                                                type={'text'}
                                                name={'cvc'}
                                                value={cardInfo.cvc}
                                                onChange={handleCVCChange}
                                                onFocus={handleInputFocus}
                                                onBlur={handleCardCVCBlurCheck}
                                                errorOccured={isCardCVCErr}
                                                errorMeesage={'Enter valid cvc'}
                                                maxLength={4}
                                            />
                                        </div>

                                    </div>


                                    <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                labelName="Name on card"
                                                placeholderName={'Cardholder Name'}
                                                type={'text'}
                                                name={'cardHolder'}
                                                value={cardInfo.cardHolder}
                                                onChange={handleInputChange}
                                                onFocus={handleInputFocus}
                                                onBlur={handleCardHolderNameBlurCheck}
                                                errorOccured={isCardHolderNameErr}
                                                errorMeesage={'Enter valid cardholder name'}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                labelName={"Zip code"}
                                                value={zipCode}
                                                onChange={(e) => { handleZipCode(e) }}
                                                onBlur={() => { handleZipCodeBlurCheck() }}
                                                errorOccured={isZipCodeErr}
                                                errorMeesage={`Enter valid zip code`}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0 justify-content-between mt-2'>
                                        <div className='col-12 px-0  mb-2'>
                                            <PrimaryButton
                                                onClick={(e) => handleSubmit(e)}
                                                buttonName={"Add new card"}
                                                type={"submit"}
                                                loadingMessage={"Loading..."}
                                                isLoading={apiResponce}
                                                style={{ width: "100%", background: 'green', border: 'none' }}
                                            />
                                        </div>

                                    </div>

                                </form> */}
                            </>






                        </div>
                    </div>



                    {/* <div>
                        <Cards
                            number={cardInfo.cardNumber}
                            name={cardInfo.cardHolder}
                            expiry={cardInfo.expiryDate}
                            cvc={cardInfo.cvc}
                            focused={cardInfo.focus}
                        />
                    </div>

                    <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>

                        <InputField
                            labelName="Cardholder Name"
                            placeholderName={'Cardholder Name'}
                            type={'text'}
                            name={'cardHolder'}
                            value={cardInfo.cardHolder}
                            onChange={handleInputChange}
                            onFocus={handleInputFocus}
                            onBlur={handleCardHolderNameBlurCheck}
                            errorOccured={isCardHolderNameErr}
                            errorMeesage={'Enter valid cardholder name'}
                        />

                        <InputField
                            labelName="Card Number"
                            placeholderName={'1234 1234 1234 1234'}
                            type={'text'}
                            name={'cardNumber'}
                            value={formatedNumber}
                            onChange={handleCardNumberChange}
                            onFocus={handleInputFocus}
                            maxLength={19}
                            onBlur={handleCardNumberBlurCheck}
                            errorOccured={isCardNumberErr}
                            errorMeesage={'Enter valid card number'}
                        />


                        <div className='combine-input-fileds' >
                            <div className='comapany-address' style={{ width: '49%' }}>
                                <InputField
                                    labelName="Expiry Date"
                                    placeholderName={'MM/YY'}
                                    type={'text'}
                                    name={'expiryDate'}
                                    value={cardInfo.expiryDate}
                                    onChange={handleExpiryDateChange}
                                    onFocus={handleInputFocus}
                                    onBlur={handleCardExpBlurCheck}
                                    errorOccured={isCardExpErr}
                                    errorMeesage={'Enter valid exp. date'}
                                />
                            </div>

                            <div className='comapany-address' style={{ width: '49%' }}>
                                <InputField
                                    labelName="CVC"
                                    placeholderName={'CVC'}
                                    type={'text'}
                                    name={'cvc'}
                                    value={cardInfo.cvc}
                                    onChange={handleCVCChange}
                                    onFocus={handleInputFocus}
                                    onBlur={handleCardCVCBlurCheck}
                                    errorOccured={isCardCVCErr}
                                    errorMeesage={'Enter valid cvc'}
                                    maxLength={3}
                                />
                            </div>
                        </div>

                        <div className='d-flex align-items-center' style={{ marginTop: '10px', justifyContent: 'flex-end' }}>

                            <PrimaryButton
                                buttonName={"Add card"}
                                onClick={handleSubmit}
                            />
                        </div>
                    </form> */}
                </Modal.Body>
            </Modal>

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
            {/* {apiResponce && <ResponceForAPI show={apiResponce} />} */}

        </>
    )
}

export default AddNewCard;